// Regex

export const NUMBER_ONLY_REGEX = new RegExp(/^\d*$/);
export const MOBILE_REGEX = new RegExp(/^\d{10}$/);
export const PIN_REGEX = new RegExp(/^\d{6}$/);
export const EMAIL_REGEX = new RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);
